export default __webpack_public_path__ + "static/media/IMG_0406-2.f1947985.jpg";